import React from 'react';
import { Box, Button, CircularProgress, FormControlLabel, Stack, TextField, Typography } from '@mui/material';

import Select from '../../../form/Select';
import TextArea from '../../../form/TextArea';
import CheckBox from '../../../form/Checkbox';

import { formatarNumero } from '../../../../utils/masks';
import { retornaDataBr } from '../../../../utils/retornaDataFormatada';

function FormBaixaAgrupada({
    dados,
    itens,
    resumo,
    optionsConta,
    isLoading,
    isSubmitting,
    isSubmitDisabled,
    handleChange,
    submit,
    onClose,
}) {
    return (
        <form onSubmit={submit}>
            {/* topo */}
            <Stack
                direction={{ xs: 'column', md: 'row' }}
                spacing={2}
                justifyContent="space-between"
                alignItems={{ xs: 'flex-start', md: 'center' }}
                sx={{ mb: 2 }}
            >
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={3}>
                    <Typography variant="body1">
                        <strong>Qtd. títulos:</strong> {resumo?.quantidade || 0}
                    </Typography>

                    <Typography variant="body1">
                        <strong>Total selecionado:</strong> {formatarNumero(resumo?.total || 0)}
                    </Typography>
                </Stack>

                <Stack direction="row" spacing={1}>
                    <Button variant="contained" color="secondary" onClick={onClose}>
                        Voltar
                    </Button>

                    <Button type="submit" variant="contained" color="success" disabled={isSubmitDisabled}>
                        Confirmar baixa
                    </Button>
                </Stack>
            </Stack>

            {/* campos */}
            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: { xs: '1fr', md: '160px 220px 160px auto' },
                    gap: 2,
                    mb: 2,
                    alignItems: 'start',
                }}
            >
                <TextField
                    label="Data da Baixa"
                    type="date"
                    name="dataBaixa"
                    value={dados?.dataBaixa || ''}
                    onChange={handleChange}
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                />

                <Select
                    name="contaId"
                    title="Conta da baixa agrupada"
                    text="Conta"
                    options={optionsConta}
                    handleOnChange={handleChange}
                    value={dados?.contaId || ''}
                    isEnum={false}
                    notOptNull={false}
                    inputWidth="100%"
                />

                <CheckBox text="Agrupar" name="agrupar" checked={!!dados?.agrupar} onChange={handleChange} />

                <TextArea
                    text="Histórico"
                    name="historico"
                    placeholder="Digite aqui o histórico da baixa"
                    title="Histórico da baixa agrupada"
                    handleOnChange={handleChange}
                    value={dados?.historico || ''}
                    linhas="2"
                    colunas="80"
                />
            </Box>

            {/* grid de conferência */}
            <Box sx={{ border: '1px solid #ddd', borderRadius: 1, overflow: 'hidden' }}>
                <Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: '2fr 1fr 1fr 1fr 1fr 1fr',
                        gap: 1,
                        px: 2,
                        py: 1.5,
                        bgcolor: '#7e6262', // Escurecido de 100 para 200
                        fontWeight: 800, // Peso maior para destaque
                        color: '#ffffff', // Garante que o texto use a cor principal
                    }}
                >
                    <Box>Parceiro</Box>
                    <Box textAlign="center">Vencimento</Box>
                    <Box textAlign="right">Título</Box>
                    <Box textAlign="center">Parcela</Box>
                    <Box textAlign="right">Pago</Box>
                    <Box textAlign="right">Aberto</Box>
                </Box>

                {isLoading ? (
                    <Box sx={{ p: 3, textAlign: 'center' }}>
                        <CircularProgress size={28} />
                    </Box>
                ) : itens?.length ? (
                    itens.map((item) => (
                        <Box
                            key={item.uuid}
                            sx={{
                                display: 'grid',
                                gridTemplateColumns: '2fr 1fr 1fr 1fr 1fr 1fr',
                                gap: 1,
                                px: 2,
                                py: 1.25,
                                borderTop: '1px solid #eee',
                                alignItems: 'center',
                                fontSize: 14,
                            }}
                        >
                            <Box>{item?.Pessoa?.nomePrincipal || ''}</Box>
                            <Box textAlign="center">{item?.dataVencimento ? retornaDataBr(item.dataVencimento) : ''}</Box>
                            <Box textAlign="right">{formatarNumero(item?.valorOriginal || 0)}</Box>
                            <Box textAlign="center">{item?.parcelas || ''}</Box>
                            <Box textAlign="right">{formatarNumero(item?.valorBaixado || 0)}</Box>
                            <Box textAlign="right">{formatarNumero(item?.valorAberto || 0)}</Box>
                        </Box>
                    ))
                ) : (
                    <Box sx={{ p: 2 }}>
                        <Typography variant="body2">Nenhum lançamento selecionado para baixa.</Typography>
                    </Box>
                )}
            </Box>
        </form>
    );
}

export default FormBaixaAgrupada;
